const hasSchool = (schoolId, schools) => !!schools
  .find((school) => school.id === parseInt(schoolId, 10));

/**
 * Inits the validator function with required parameters
 * @param {object} schools On form {university: [{id: number}], college: [{id:number}]}
 * @retrun {function}
 * */
// eslint-disable-next-line import/prefer-default-export
export function initValidator(schools) {
  return (values) => {
    const {
      address,
      school,
      postalCity,
      studyLevel,
    } = values;
    const errors = {};

    const isSchoolSelected = (!!school && school !== 'default');

    // Check if the overall values are selected before proceeding
    // to do granular checks
    if ((!isSchoolSelected || studyLevel === 'default') && !address) {
      errors.global = 'Fyll inn adresse og postnummer eller velg studiested';
      return errors;
    }

    const usesSalePoint = !!address;

    if (usesSalePoint && (address.length < 2 || address.length > 200)) {
      errors.address = `Adressen må være mellom 2 til 200 tegn. Ditt er ${address.length}`;
    }

    if (usesSalePoint && !postalCity) {
      errors.postalCity = 'Postnummeret du fylte inn gav ikke en kjent adresse';
    }

    if (!usesSalePoint && !isSchoolSelected) {
      errors.school = 'Ingen skole er valgt';
    }

    const isInAnySchool = hasSchool(school, schools.college)
      || hasSchool(school, schools.university);

    if (!usesSalePoint && !isInAnySchool) {
      errors.school = 'Finner ikke skolen du har valgt';
    }

    return errors;
  };
}
